import UcMeterReadings from './UcMeterReadings.yaml?component';

export { UcMeterReadings };
